// 学生api

import { baseRequest, fileRequest, fileUploadRequest } from './base'

/**
 * @desc 查询学生列表
 */
function getStudentList(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaStudent/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 删除学生列表接口
 */
function deleteStudentList(id) {
  //清除空白字段
  let tempUrl = `/api/pcWeb/preOrder/delete/${id}`
  return baseRequest(tempUrl, 'get')
}

/**
 * @desc 查询学生列表
 */
function getPreOrderList(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/preOrder/list'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 根据学生ID获取学生信息
 */
function getStudentById(id) {
  return baseRequest(`/api/pcWeb/teaStudent/${id}`, 'get')
}

/**
 * @desc 新增学生
 */
function addStudent(params) {
  return baseRequest(`/api/pcWeb/teaStudent/create`, 'post', params)
}

/**
 * @desc 删除学生
 */
function deleteStudent(id) {
  return baseRequest(`/api/pcWeb/teaStudent/delete/${id}`, 'get')
}

/**
 * @desc 导入学生信息
 */
function importStudent(params) {
  return fileRequest(`/api/pcWeb/teaStudent/importStudent`, params)
}

/**
 * @desc 修改学生
 */
function updateStudent(id, params) {
  //清除空白字段
  // params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaStudent/update/${id}`, 'post', params)
}

/**
 * @desc 查看学生所报班级
 */
function getApplyClass(id) {
  return baseRequest(`/api/pcWeb/teaStudent/getApplyClass/${id}`, 'get')
}

/**
 * @desc 导出学生报班
 */
function exportApplyStudent(params) {
  return fileUploadRequest(`/api/pcWeb/teaStudent/exportApplyStudent`, params)
}
/**
 * @desc 导出学生全体信息
 */
function exportAllStudent(id) {
  return fileUploadRequest(`/api/pcWeb/teaStudent/exportAllStudentSource`, id)
}

/**
 * @desc 校验导入文件表头
 */
function checkHeader(params) {
  return fileRequest(`/api/pcWeb/teaStudent/checkHeader`, params)
}

/**
 * @desc 校验导入文件信息
 */
function checkFileInfo(params) {
  return fileRequest(`/api/pcWeb/teaStudent/checkFileInfo`, params)
}

/**
 * @desc 批量删除学生
 */
function batchDelete(params) {
  return baseRequest(`/api/pcWeb/teaStudent/batchDelete`, 'post', params)
}

/**
 * @desc 签到记录修改
 */
function updateCheckin(id, params) {
  return baseRequest(`/api/pcWeb/teaCheckin/update/${id}`, 'post', params)
}

/**
 * @desc 归档学生名单
 */
function archiveStudent(params) {
  let tempUrl = `/api/pcWeb/teaStudent/selectHasArchiveStudent`
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 归档学生名单导出
 */
 function exportArchiveStudent(params) {
  let tempUrl = `/api/pcWeb/teaStudent/exportArchiveStudent`
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 是否显示家校通讯录
 */
function showHSdirectory(params) {
  let tempUrl = '/api/pcWeb/teaStudent/getTeaSchoolStatus'
  return baseRequest(tempUrl, 'get', params, true, false)
}

/**
 * @desc 同步家校通讯录
 */
function HSdirectory(params) {
  let tempUrl = '/api/pcWeb/teaStudent/syncDingTalkContact'
  return baseRequest(tempUrl, 'get', params)
}
/**
 * @desc 解除家长绑定
 */
function unbindRelation(params) {
  let tempUrl = '/api/pcWeb/teaStudent/unbindParentAndStudentRelation'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 学生管理批量归档
 */
function batchArchiving(params) {
  let tempUrl = '/api/pcWeb/teaStudent/batchArchive'
  return baseRequest(tempUrl, 'post', params)
}

/**
 * @desc 学生管理批量取消归档
 */
function batchCancelArchive(params) {
  let tempUrl = '/api/pcWeb/teaStudent/batchCancelArchive'
  return baseRequest(tempUrl, 'post', params)
}

/**
 * @desc 预报名学生列表
 */
 function getPreRegistrationList(params) {
  let tempUrl = '/api/pcWeb/teaStudent/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 获取手机明文
 */
function getMobile(params) {
  let tempUrl = '/api/pcWeb/teaStudent/getMobile'
  return baseRequest(tempUrl, 'get', params)
}

export default {
  getStudentList,
  deleteStudentList,
  getPreOrderList,
  getStudentById,
  addStudent,
  deleteStudent,
  updateStudent,
  importStudent,
  getApplyClass,
  exportApplyStudent,
  checkHeader,
  checkFileInfo,
  batchDelete,
  updateCheckin,
  archiveStudent,
  exportArchiveStudent,
  exportAllStudent,
  showHSdirectory,
  HSdirectory,
  unbindRelation,
  getPreRegistrationList,
  batchArchiving,
  getMobile,
  batchCancelArchive
}
